import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import "./PatientAdditionalViewComponent.scss";
import {CommonService} from "../../../../../shared/services";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from '@mui/icons-material/Edit';
import AttachmentViewDownloadComponent
    from "../../../../../shared/components/core/attachment-view-download/attachmentViewDownloadComponent";
import commonService from "../../../../../shared/services/common.service";

interface PatientAdditionalViewComponentProps {
    patientDetails: any;
    canEdit: boolean;
    onEditModeOpen: () => void;
}

type Attachment = {
    id: number;
    patientId: number;
    title: string;
    secureUrl: string;
    mimeType: string;
    attachmentType: string;
    attachmentName: null;
    createdAt: string;
    updatedAt: string;
    url: string;
};

const getDrivingLicenseAttachments = (results: Attachment[]): Attachment[] => {
    return results?.filter(attachment => attachment?.attachmentType === 'drivingLicense');
};

const PatientAdditionalViewComponent = (props: PatientAdditionalViewComponentProps) => {
    const {patientDetails, onEditModeOpen, canEdit} = props;
    const drivingLicenseAttachments = getDrivingLicenseAttachments(patientDetails?.patientAttachments || []);

    return (
        <div className={'patient-additional-view-component details-tab-data-content'}>
            {patientDetails && <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Additional Details</div>
                    {canEdit &&
                        <div className={'edit-action-button'}>
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Alias Name"}> {patientDetails?.aliasName || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Social Security Number"}> {patientDetails?.ssn || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Marital Status"}> {patientDetails?.maritalStatus || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Alternate ID 1"}> {patientDetails?.alternateId1 || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Custom Field 1"}> {patientDetails?.customField1 || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Custom Field 3"}> {patientDetails?.customField3 || 'N/A'} </DetailsDataKeyValueComponent>

                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Patient Account Number"}> {patientDetails?.patientAccountNumber || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Nationality"}> {patientDetails?.nationality || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Degree"}> {patientDetails?.degree || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Alternate ID 2"}> {patientDetails?.alternateId2 || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Custom Field 2"}> {patientDetails?.customField2 || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>

                    <div className="horizontal-line"/>
                    <div className="view-and-edit-title">Additional IDs</div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Patient ID 1"}> {patientDetails?.patientId1 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Patient ID 2"}> {patientDetails?.patientId2 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Patient ID 3"}> {patientDetails?.patientId3 || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"ID 1 Assigned By"}> {patientDetails?.assignedBy1 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"ID 2 Assigned By"}> {patientDetails?.assignedBy2 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"ID 3 Assigned By"}> {patientDetails?.assignedBy3 || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                    </div>

                    <div className="horizontal-line"/>
                    <div className="view-and-edit-title">Driving License</div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Is driving license available"}> {patientDetails?.isDrivingLicenseAvailable ? 'Yes' : 'No'} </DetailsDataKeyValueComponent>
                                {patientDetails?.isDrivingLicenseAvailable && <DetailsDataKeyValueComponent
                                    title={"Attachment"}>

                                    <div className="attachment-list-wrapper">
                                        {
                                            drivingLicenseAttachments?.length > 0 ? drivingLicenseAttachments?.map((attachment: any) =>
                                                <div key={CommonService.getUUID()}>
                                                    <AttachmentViewDownloadComponent
                                                        attachmentTitle={attachment.attachmentName}
                                                        attachment={attachment}
                                                    />
                                                </div>
                                            ) : "N/A"
                                        }
                                    </div>
                                </DetailsDataKeyValueComponent>}
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                {patientDetails?.isDrivingLicenseAvailable && <DetailsDataKeyValueComponent
                                    title={"Driving license number"}> {patientDetails?.drivingLicenseNumber || 'N/A'} </DetailsDataKeyValueComponent>}
                            </Grid>
                        </Grid>
                    </div>

                    <div className="horizontal-line"/>
                    <div className="view-and-edit-title">Patient death details</div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Is patient dead"}> {patientDetails?.isPatientDead ? 'Yes' : 'No'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Time of Death"}> {patientDetails?.timeOfDeath ? commonService.convertTo12HourFormat(patientDetails?.timeOfDeath, 'hh:mm A') : 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Date of Death"}> {patientDetails?.dateOfDeath ? commonService.formatDate(patientDetails?.dateOfDeath) : 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </>
            }
        </div>
    );

};

export default PatientAdditionalViewComponent;
